import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';

const getNode = (nodeId: number | undefined): Promise<IGetNodeViaID> => {
  return axiosDefaultApi.get(`/api/Nodes/GetNodeViaID/${nodeId}`);
};

type QueryFnType = typeof getNode;

type UseGetNodeOptions = {
  nodeId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetNode = ({ nodeId , config }: UseGetNodeOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getNode'],
    queryFn: () => getNode(nodeId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Κόμβου.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};